
(function() {
    'use strict';
    
    var getConfig = function() {
      var configElement = document.getElementById('videoWikiConfig');
      if (configElement) {
        try {
          return JSON.parse(configElement.textContent);
        } catch (e) {
          console.error('Error parsing Video Wiki config:', e);
        }
      }
      return { realtimeSearch: true };
    };
    
    var videoWikiInit = function() {
      try {
        console.log('Video Wiki initializing...');
        
        var config = getConfig();
        
        var categoryLinks = document.querySelectorAll('.video-wiki-category-item a');
        var videoCards = document.querySelectorAll('.video-wiki-card');
        var clearFilterBtn = document.getElementById('clearVideoFilter');
        var isFiltered = false;
        var searchTimeout = null;
        var searchInput = document.getElementById('videoWikiSearch');
        var lightbox = document.querySelector('.video-lightbox');
        var lightboxIframe = document.querySelector('.video-lightbox-iframe');
        var lightboxClose = document.querySelector('.video-lightbox-close');
        
        function showAllVideos() {
          videoCards.forEach(function(card) {
            card.style.display = 'block';
          });
          
          categoryLinks.forEach(function(link) {
            link.parentElement.classList.remove('active');
          });
          
          if (categoryLinks.length > 0) {
            categoryLinks[0].parentElement.classList.add('active');
          }
          
          if (clearFilterBtn) {
            clearFilterBtn.classList.remove('active');
          }
          
          if (searchInput) {
            searchInput.value = '';
          }
          
          isFiltered = false;
        }
        
        if (clearFilterBtn) {
          clearFilterBtn.addEventListener('click', function() {
            showAllVideos();
          });
        }
        
        if (categoryLinks.length > 0) {
          categoryLinks.forEach(function(link) {
            link.addEventListener('click', function(e) {
              e.preventDefault();
              
              categoryLinks.forEach(function(l) {
                l.parentElement.classList.remove('active');
              });
              this.parentElement.classList.add('active');
              
              var category = this.getAttribute('data-category');
              
              if (category === 'All') {
                showAllVideos();
                return;
              }
              
              if (clearFilterBtn) {
                clearFilterBtn.classList.add('active');
              }
              
              isFiltered = true;
              
              videoCards.forEach(function(card) {
                if (card.getAttribute('data-category') === category) {
                  card.style.display = 'block';
                } else {
                  card.style.display = 'none';
                }
              });
            });
          });
        }
        
        if (searchInput) {
          function performSearch() {
            var searchTerm = searchInput.value.toLowerCase();
            
            if (searchTerm && clearFilterBtn) {
              clearFilterBtn.classList.add('active');
              isFiltered = true;
            } else if (!isFiltered && clearFilterBtn) {
              clearFilterBtn.classList.remove('active');
            }
            
            videoCards.forEach(function(card) {
              var title = card.querySelector('.video-wiki-title').textContent.toLowerCase();
              var tagElements = card.querySelectorAll('.video-wiki-tag');
              var tags = [];
              
              tagElements.forEach(function(tag) {
                tags.push(tag.textContent.toLowerCase());
              });
              
              if (title.includes(searchTerm) || tags.some(function(tag) { return tag.includes(searchTerm); })) {
                card.style.display = 'block';
              } else {
                card.style.display = 'none';
              }
            });
          }
          
          if (config.realtimeSearch) {
            searchInput.addEventListener('input', function() {
              if (searchTimeout) {
                clearTimeout(searchTimeout);
              }
              
              searchTimeout = setTimeout(function() {
                performSearch();
              }, 300);
            });
          }
          
          searchInput.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
              if (searchTimeout) {
                clearTimeout(searchTimeout);
              }
              performSearch();
            }
          });
          
          window.searchVideos = function() {
            performSearch();
          };
        }
        
        if (videoCards.length > 0 && lightbox && lightboxIframe) {
          console.log('Setting up video card click handlers for ' + videoCards.length + ' cards');
          
          videoCards.forEach(function(card) {
            card.addEventListener('click', function() {
              console.log('Video card clicked');
              var youtubeId = this.getAttribute('data-youtube-id');
              console.log('YouTube ID: ' + youtubeId);
              
              if (youtubeId) {
                lightboxIframe.src = 'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1';
                lightbox.classList.add('active');
                document.body.style.overflow = 'hidden';
              }
            });
          });
          
          if (lightboxClose) {
            lightboxClose.addEventListener('click', function() {
              lightbox.classList.remove('active');
              lightboxIframe.src = '';
              document.body.style.overflow = '';
            });
          }
          
          lightbox.addEventListener('click', function(e) {
            if (e.target === lightbox) {
              lightbox.classList.remove('active');
              lightboxIframe.src = '';
              document.body.style.overflow = '';
            }
          });
        } else {
          console.log('Could not initialize video lightbox. Missing elements.');
          if (!videoCards.length) console.log('No video cards found');
          if (!lightbox) console.log('Lightbox element not found');
          if (!lightboxIframe) console.log('Lightbox iframe not found');
        }
        
        console.log('Video Wiki initialization complete');
      } catch (error) {
        console.error('Error initializing Video Wiki:', error);
      }
    };
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', videoWikiInit);
    } else {
      videoWikiInit();
    }
    
    setTimeout(videoWikiInit, 1000);
  })();